var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    fillRule: "evenodd",
    d: "M0 2.819c0-.688.204-1.26.612-1.72C1.021.642 1.632.413 2.45.413s1.436.23 1.859.688c.422.458.633 1.031.633 1.719 0 .658-.21 1.21-.633 1.654-.423.444-1.042.666-1.859.666-.816 0-1.428-.222-1.837-.666C.204 4.029 0 3.477 0 2.819zm9.389 0c0-.688.204-1.26.612-1.72.408-.458 1.02-.687 1.837-.687.816 0 1.436.23 1.858.688.423.458.634 1.031.634 1.719 0 .658-.211 1.21-.634 1.654-.422.444-1.042.666-1.858.666-.817 0-1.429-.222-1.837-.666-.408-.444-.612-.996-.612-1.654zm8.916 0c0-.688.204-1.26.612-1.72.408-.458 1.02-.687 1.837-.687.816 0 1.436.23 1.858.688.423.458.634 1.031.634 1.719 0 .658-.211 1.21-.634 1.654-.422.444-1.042.666-1.858.666-.817 0-1.429-.222-1.837-.666-.408-.444-.612-.996-.612-1.654z",
    opacity: 0.9
  })));
}
export default SvgNoResult;